import styled from 'styled-components'

const Container = styled.div`
    padding: 0 0 28px 0;
`
const Wrapper = styled.div`
  max-width: 1423px;
  margin: 0 auto;
  padding: 0 10px;
  > div {
    flex: 1;
  }
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`;
const DropDownDiv = styled.div`
display: grid;
flex-wrap: wrap;
padding: 0 0 0 0;
align-items: center;
grid-template-columns: 110px 1fr 3.4fr 0fr 0fr 2fr;
> div:first-child {
    width: 110px;
}
> div:nth-child(2) {
    width: 110px;
}

h6 {
    font-size: 18px;
    text-align: right;
}
@media (max-width: 767px) {
    display: inline-flex;
    width: 100%;
    > div {
        float: left;
        max-width: 50%;
        margin-bottom: 10px;
    }
}
`;
const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 267px 1fr;
  grid-gap: 20px;
  align-items: flex-start;
  padding-top: 30px;
  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    padding-top: 15px;
  }
`;

const ButtonGroup = styled.ul`
margin-bottom: 0;
  li {
    border-top: solid 1px #c2c2c2;
    min-height: 51px;
    font-size: 20px;
    padding: 13px;
    color: #00446e;
    text-transform: capitalize;
    align-items: center;
    grid-gap: 10px;
    grid-template-columns: 39px auto;
    display: grid;
    cursor: pointer;
    svg {
      margin: 0 auto;
    }
    img {
      margin: 0px 0px 3px 7px;
    }
  }
  @media (max-width:1023px) {
    li {
      /* display: none; */
      :last-child {
        display: grid;
        grid-template-columns: auto 1fr;
      }
    }
  }
`
const ProFileWrapper = styled.div`
  border-radius: 17px;
  box-shadow: 2px 3px 0 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdcdcd;
  background-color: #fff;
  position: sticky;
    top: 109px;
    @media (max-width:1023px) {
      display: none;
    }
`


const SearchSection = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  max-width: 565px;
    width: 100%;
    .type-ahead-search-input {
      width: 100%;
      > div {
        input {
    border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #dcdcdc;
  height: 40px;
  width: 100%;
  padding: 0 17px;
  ::-webkit-input-placeholder { /* Edge */
  color: #00000061;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #00000061;
}

::placeholder {
  color: #00000061;
}
  }
    }
    }
  
  button {
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #dcdcdc;
  color: #00446e;
  font-size: 16px;
  font-family: 'latobold';
  background: #fff;
    height: 40px;
    width: 98px;
  }
`

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
    gap: 15px;
    @media (max-width:1023px) {
      flex-wrap: wrap;
    }
    @media (max-width:840px) {
      flex-direction: column-reverse;
    padding: 10px 0 15px;
    position: sticky;
    top: 81px;
    background: #fff;
    z-index: 1;
    margin: 0;
    margin-bottom: 5px;
      ${SearchSection} {
      max-width: 100%;
    }
    }
   

`

const LinksSection = styled.ul`
margin-bottom: 0;
display: flex;
color: #00446e;
font-size: 15px;
gap: 11px;
align-items: center;
li {
  display: grid;
    align-items: center;
    justify-content: center;
    text-transform: capitalize;
    cursor: pointer;
    white-space: nowrap;
    position: relative;

    svg {
      margin: 0 auto;
    }
    p.notification {
      position: absolute;
      font-size: 10px;
      background: #3fb144;
      border-radius: 50%;
      padding: 2px;
      height: 22px;
      width: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      color: #fff;
      font-weight: bold;
      top: -8px;
    right: 15px;
  }
}
button {
  font-size: 16px;
  /* width: 99px; */
  height: 36px;
  background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
  border: none;
  border-radius: 5px;
  color: #fff;
}
`

const BoxContainer = styled.div`
 border-radius: 17px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
`

const BoxContainerHeader = styled.div`
  border-bottom: solid 1px #c9c9c9;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 55px;
  position: relative;
  .clear-icon{
    display:flex;
    svg{
      margin-top: 7px;
      margin-right: 10px;
    }
  }
  .invite-select {
    min-width: 160px;
    position: absolute;
    left: 250px;
    top: 9px;
    .css-os3nnz-control {
      border-radius: 5 px;
      box-shadow: 0 3px 10px 0 rgb(0 0 0 / 16%);
      background-color: #fff;
      border: none;
    }
    .css-1r0b6xv-control:hover {
      border-color: transparent;
      border: none;
    }
    .app-input-text {
      margin: 0;
      input {
        border-radius: 5px;
        box-shadow: 0 3px 10px 0 rgb(0 0 0 / 16%);
        background-color: #fff;
        border: none;
      }
    }
  }
  h2 {
    font-size: 25px;
    color: #00446e;
    text-transform: capitalize;
    font-family: "latobold";
    span{
      font-size: 16px;
      color: #606060;
    }
  }
  .close-icon-black-bg {
    cursor: pointer;
    min-width: 24px;
  }
  @media (max-width: 650px) {
    align-items: flex-start;
    h2 {
      font-size: 20px;
    }
    .invite-select {
      position: unset;
    }
  }
`;
const CreateGroupWrappe = styled.div`
.image-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: solid 1px #c9c9c9;
  h3 {
    font-size: 16px;
    color: #606060;
    font-family: 'latobold';
    padding: 15px;
    text-align: right;

  }
  .image-wrapper {
  width: 121px;
  height: 121px;
  border-radius: 50%;
  overflow: hidden;
  margin: 30px 15px 17px 30px;
  position: relative;
  .image-upload-icon {
    position: absolute;
    right: 6px;
    bottom: 26px;
    cursor: pointer;
  }
  img {
    width: 100%;
  }
 
}
}
`
const InputSection = styled.div`
  border-bottom: solid 1px #c9c9c9;
  padding: 36px 20px;
  .lable {
    font-family: "latobold";
    font-size: 20px;
    color: #00446e;
    margin-bottom: 23px;
  }
  .app-input-text {
    input,
    textarea {
      border-radius: 4px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #dcdcdc;
      background-color: #f8f8f8;
      max-width: 436px;
    }
  }
`;
const GroupDiscoverability = styled.div`
  h2 {
    font-family: "latobold";
    font-size: 20px;
    color: #00446e;
    padding: 18px 20px;
  }
  .radio-container {
    font-size: 17px !important;
  }
  .radio-field,
  .checkbox-field-wrapper {
    padding: 0 20px;
    font-size: 18px;
    font-family: "latobold";
    color: #0000009c;
    .checkbox-field {
      margin-top: 0;
    }
    .checkbox-container {
      font-family: "latobold" !important;
      font-size: 17px !important;

    }
  }
  @media (max-width:650px) {
    .checkbox-field-wrapper {
      .checkbox-container {
      font-size: 15px !important;
    }
    }
    .radio-container {
      font-size: 15px !important;

    }
  }
`;
const ActionBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  .app-green-button {
    background: transparent;
  }
  button {
    border-radius: 10px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ebe6e6;
    background-color: #fff;
    font-family: "latobold";
    font-size: 16px;
    padding: 0 20px;
    color: #00446e;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
`;
const ProfilePicWrapper = styled.div`
  background-color: #fff;

    border-radius: 15px;
    box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #f2f2f2;
    margin: 28px 12px 56px;
    height: 225px;
  
  img {
    max-width: 60px;
    border-radius: 50%;
    border: 4px solid #fff;
    overflow: hidden;
    width: 60px;
    object-fit: cover;
    height: 60px;
  }
  @media (max-width: 1023px) {
    display: none;
  }
`;

const ProfileDpsection = styled.div`
  min-height: 257px;
  margin: 30px 14px 20px;
  border-radius: 15px;
  box-shadow: 0 2px 0 0 #00000029;
  border: solid 1px #f2f2f2;
  position: relative;
  background: linear-gradient(0deg, #fff 70%, #00446e 70%);
  .photo-upload-icon {
    display: none;
  }
 
  .icon-section {
    min-width: 120px;
    min-height: 120px;
    height: 22px;
    max-width: 120px;
    position: absolute;
    cursor:pointer;
    right: 0;
    left: 0;
    margin: 0 auto;
    top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 15px;
  }
  @media (max-width: 1023px) {
    min-height: auto;
    margin: 0;
    background: no-repeat;
    border-radius: 15px 15px 0 0;
    .icon-section {
      min-width: 77px;
      max-width: 77px;

    margin: 0;
    top: 50%;
    right: 0;
    }
    .picture-box-container {
      display: flex;
    align-items: center;
    h3 {
      font-size: 20px;
    }
    }
    .picture-box {
      min-width: 60px;
      min-height: 60px;
      max-width: 60px;
      max-height: 60px;
      margin: 10px;
    }
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap:15px;
  flex-wrap: wrap;
`

const LogsTableWrapper = styled.div`
  .table td {
      border: none;
      max-width: 300px;
      overflow-wrap: break-word;
  }
`;


export {
  Container,
  Wrapper,
  SectionWrapper,
  ButtonGroup,
  ProFileWrapper,
  HeaderSection,
  SearchSection,
  LinksSection,
  BoxContainer,
  BoxContainerHeader,
  CreateGroupWrappe,
  InputSection,
  GroupDiscoverability,
  ActionBtn,
  ProfilePicWrapper,
  ProfileDpsection,
  SelectWrapper,
  LogsTableWrapper,
  DropDownDiv
};